import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import type { MyProfileResponse } from '@/entities/employee/model/types'
import { WelcomeCard } from './WelcomeCard'
import { ProfileBasicsCard } from './ProfileBasicsCard'

type OnboardingStep = 'welcome' | 'profile'

type OnboardingExperienceProps = {
  currentUser: MyProfileResponse
}

export function OnboardingExperience({ currentUser }: OnboardingExperienceProps) {
  void currentUser
  const [step, setStep] = useState<OnboardingStep>('welcome')

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={step}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.25 }}
      >
        {step === 'welcome' && <WelcomeCard onContinue={() => setStep('profile')} />}
        {step === 'profile' && <ProfileBasicsCard onDone={() => undefined} />}
      </motion.div>
    </AnimatePresence>
  )
}
